module.exports = __webpack_public_path__ + "img/react-admin.05d368eb.png";